declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    clarity?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export const AnalyticsEvents = {
  PAGE_VIEW: "page_view",
  ADD_TO_CART: "add_to_cart",
  REMOVE_FROM_CART: "remove_from_cart",
  CART_CLEARED: "cart_cleared",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
} as const;

type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

export function trackEvent(
  eventName: AnalyticsEventName | string,
  params?: Record<string, unknown>,
): void {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch {
    // Silently ignore — analytics must never break the app
  }
}

export function trackPageView(path: string, title?: string): void {
  trackEvent(AnalyticsEvents.PAGE_VIEW, {
    page_path: path,
    page_title: title ?? document.title,
  });
}

export function trackAddToCart(
  itemType: "Logo" | "Design",
  itemId: string,
): void {
  trackEvent(AnalyticsEvents.ADD_TO_CART, {
    item_type: itemType,
    item_id: itemId,
  });
}

export function trackRemoveFromCart(itemId: string): void {
  trackEvent(AnalyticsEvents.REMOVE_FROM_CART, {
    item_id: itemId,
  });
}

export function trackCartCleared(): void {
  trackEvent(AnalyticsEvents.CART_CLEARED);
}

export function trackBeginCheckout(itemCount: number): void {
  trackEvent(AnalyticsEvents.BEGIN_CHECKOUT, {
    item_count: itemCount,
  });
}

export function trackPurchase(orderId: number, orgId: number): void {
  trackEvent(AnalyticsEvents.PURCHASE, {
    transaction_id: orderId.toString(),
    organization_id: orgId,
  });
}
